export default "__VITE_ASSET__DjwvBDjB__"